import { createSlice } from '@reduxjs/toolkit'

export const userUI = createSlice({
  name: 'userUI',
  initialState: {
    user: null,
    school: null,
    gradeScale: null
  },
  reducers: {
    setUser: (state, { payload }) => {
      state.user = payload
    },
    setSchool: (state, { payload }) => {
      state.school = payload
    },
    setGradeScale: (state, { payload }) => {
      state.gradeScale = payload
    },
  },
})

export const { setUser, setSchool, setGradeScale } = userUI.actions

export default userUI.reducer
